<script lang="ts">
    import { Button,Col, Form, Input, Label,Modal, ModalBody, ModalHeader, Row } from "sveltestrap";
    import { EditBookmark, WebUrl ,Titles, Descriptions, Group, MyBookmarks, Collection, General, Fs, Save, Cancel} from "../../../utils/Constant/Constant";
    import {newBookmarkAdd,open,editBookmark} from "../../../store"
    type filterdata= {
        img: string;
        id: string;
        header: string;
        fillstar: boolean;
        link: string;
        content: string;
        title: string;
        class: string;
        class2: string;
    }[]
    let isOpen:boolean
    open.subscribe((value)=>{
        isOpen = value
    })
    let setNewBookmarkAdd:filterdata
    newBookmarkAdd.subscribe((value)=>{
        setNewBookmarkAdd = value
    })
    let setEditBookmark
    editBookmark.subscribe((value)=>{
        setEditBookmark = value
    })
    const handleEdit = (e)=>{
        e.preventDefault()
        let editData = {
            "img":"06.jpg",
            "id":setEditBookmark.getId,
            "fillstar":false,
            "header":setEditBookmark.titles,
            "link":setEditBookmark.weburl,
            "content":setEditBookmark.description,
            "title":"Fs",
            "class":"collection_5",
            "class2":"favourite_5"
        }
    newBookmarkAdd.update(value => value = setNewBookmarkAdd.map((data)=> data.id == setEditBookmark.getId ? editData : data ))
        open.update(value => value = !value)
    }
</script>
<div class="fade modal-bookmark"  tabindex="-1"   aria-hidden="true">
    <Modal {isOpen} class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <ModalHeader> {EditBookmark} </ModalHeader>
        <ModalBody>
          <Form class="form-bookmark needs-validation"  >
            <Row class="g-2">
              <Col md="12" class="mb-3 mt-0">
                <Label for="bm-weburl">{WebUrl}</Label>
                <Input id="bm-weburl" type="text" bind:value={setEditBookmark.weburl} required autocomplete="off"/>
              </Col>
              <Col md="12" class="mb-3 mt-0">
                <Label for="bm-title">{Titles}</Label>
                <Input id="bm-title" type="text" bind:value={setEditBookmark.titles} required autocomplete="off"/>
              </Col>
              <Col md="12" class="mb-3 mt-0">
                <Label>{Descriptions}</Label>
                <textarea class="form-control" id="bm-desc" required bind:value={setEditBookmark.description} autocomplete="off"></textarea>
              </Col>
              <Col md="6" class="mb-3 mt-0">
                <Label>{Group}</Label>
                <Input type="select" name="select" id="exampleSelect" value="My Bookmarks">
                    <option>{MyBookmarks}</option>
                </Input>
              </Col>
              <Col md="6" class="mb-3 mt-0">
                <Label>{Collection}</Label>
                <Input type="select" name="select" id="exampleSelect" value="General">
                    <option>{General}</option>
                    <option>{Fs}</option>
                </Input>
              </Col>
            </Row>
            <Input id="index_var" value="6"/>
            <Button color="secondary" on:click={(e)=>handleEdit(e)} type="submit">{Save}</Button>
            <Button color="primary" on:click={()=>open.update(value => value = !value)}>{Cancel}</Button>
          </Form>
        </ModalBody>
      </div>
    </Modal>
</div>